import React, { useEffect, useState } from 'react'
import { AbstructVar } from '../../components/general/general-component/abstruct-component/AbstructVar'
import { AbstructLang } from '../../components/general/general-component/abstruct-component/AbstructLang'
import '../../components/creative-work-requests/evaluation-details/EvaluationDetails.css'
import './ScriptsArchive.css'
import CheckLazyLoader from '../../components/general/general-component/check-lazy-loader'
import { deleteScriptsArchive, loadScriptsArchive } from '../../store/Actions/ActionScriptArchive'
import { useSelectorCustom } from '../../components/general/general-component/abstruct-component/useSelectorCustom'
import { DeleteComponent } from '../../components/general/general-component/abstruct-component/DeleteComponent'
import Warning from '../../components/general/general-component/warning-delete/Warning'
import InnerLoader from '../../components/general/inner-loader/InnerLoader'
import CheckPermissions from '../../components/general/general-component/check-permissions'
import { hasPermissions, UsePermissions } from '../../components/general/general-component/abstruct-component/UsePermissions'

function ScriptsArchive() {
    const { permissionss, loadingMainPermission } = UsePermissions();
    const script_archive = hasPermissions([{ name: "script-archive" }], permissionss)
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { scriptsArchive, loadingScriptsArchive } = useSelectorCustom()
    const { translate } = AbstructLang()
    const { stateD, warning, setdeletee, setloadDel } = DeleteComponent()
    const [scriptsArchiveArr, setScriptsArchiveArr] = useState([])
    const [isDeleted, setIsDeleted] = useState('')
    const [idDeleted, setIdDeleted] = useState(null)
    useEffect(() => {
        if (isDeleted && idDeleted) {
            const updatedArr = [...scriptsArchiveArr];
            const indexToDelete = updatedArr.findIndex(item => item.id === idDeleted);
            if (indexToDelete !== -1) {
                updatedArr.splice(indexToDelete, 1);
                setScriptsArchiveArr(updatedArr);
            }
        }
    }, [isDeleted, idDeleted, scriptsArchiveArr]);
    useEffect(() => {
        if (scriptsArchive?.length >= 0) {
            setScriptsArchiveArr(scriptsArchive)
        }
    }, [scriptsArchive]);
    const handleDelete = (id) => {
        dispatch(deleteScriptsArchive(id, setloadDel, setIsDeleted, setIdDeleted));
    }
    useEffect(() => {
        dispatch(loadScriptsArchive())
    }, [])
    return (
        <CheckLazyLoader>
            <CheckPermissions array={script_archive} loadingMainPermission={loadingMainPermission} >
            <main>
                <div className='div_table margin_main shadow_main' >
                    <div className='scripts_archive' dir={langLocal === 'ar' ? "rtl" : "ltr"}>
                        <div className='d-flex' style={{ justifyContent: "space-between" }} >
                            <h4 style={{ marginBottom: '0px' }} className={`header-title ${langLocal === 'ar' ? "textAlignRight" : ""}`}>{translate('summaries-attachments-files')}</h4>
                            <button onClick={() => navigate('/add-scripts-archive')} className='btn_top_table'>Add New</button>
                        </div>
                        <br></br><br></br>
                        <div className='files' >
                            {
                                !loadingScriptsArchive ?
                                scriptsArchiveArr?.map((script) => {
                                    return (
                                        <div className='one-file' style={{ position: "relative" }} onClick={(e) => {e.stopPropagation();navigate(`/scripts-archive/${script?.id}`)}} >
                                            <div className='episodee' >{script?.episodes_count}</div>
                                            <div className='delete-srcipt-archive' onClick={(e) => { e.stopPropagation(); warning(script)}} >
                                                <i className='fa fa-trash'></i>
                                            </div>
                                            <img className='logo-script' src={script?.thumbnail} />
                                            <h2>{script?.name}</h2>
                                            <p>{script?.description}</p>
                                            <hr />
                                            <div class='file-info'>
                                                <div className='file-info-status' >
                                                    <i className='fa fa-circle' style={{
                                                        color: script?.status === 'active' ? "green" : "red"
                                                    }} ></i>
                                                    <span>{script?.status}</span>
                                                </div>
                                                <span>{script?.creative_work_type?.type}</span>
                                            </div>
                                        </div>
                                    )
                                }):<InnerLoader />
                            }
                        </div>
                    </div>
                </div>
                {
                    stateD.deletee == true ? (
                        <Warning loadDel={stateD.loadDel} arr={stateD.arrW} open={stateD.deletee} setOpen={setdeletee} handleDelete={handleDelete} />
                    ) : <></>
                }
            </main>
            </CheckPermissions>
        </CheckLazyLoader>
    )
}

export default ScriptsArchive